import { render, staticRenderFns } from "./ListPropagandaElectoral.vue?vue&type=template&id=52e28163&scoped=true"
import script from "./ListPropagandaElectoral.vue?vue&type=script&lang=js"
export * from "./ListPropagandaElectoral.vue?vue&type=script&lang=js"
import style0 from "./ListPropagandaElectoral.vue?vue&type=style&index=0&id=52e28163&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e28163",
  null
  
)

export default component.exports